import React from 'react';

/** Red and charcoal diagonal bars, echoing the stripes in the Liftoff mark. */
export function DiagonalAccent({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 120 40" className={className} aria-hidden="true" focusable="false" data-id="element-459" data-mp="2j1rbyqikqrq9">
      <polygon points="18,0 40,0 22,40 0,40" className="fill-brand-red" data-id="element-460" data-mp="2izel1nuu9712" />
      <polygon points="50,0 72,0 54,40 32,40" className="fill-charcoal-600" data-id="element-461" data-mp="2e13d5io3t6lh" />
      <polygon points="82,0 104,0 86,40 64,40" className="fill-brand-red" data-id="element-462" data-mp="2s1e4snx8mp7p" />
    </svg>;
}